import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SlidersHorizontal } from "lucide-react";
import { SearchBar } from "../SearchBar";
import { FilterBottomSheet } from "../FilterBottomSheet";
import type { GroupSelectorGroup } from "../GroupSelector";
import type { FilterPeriod } from "../../base/FilterChips";
import styles from "./FiltersSection.module.css";

export interface FiltersSectionProps {
  search: string;
  filterPeriod: FilterPeriod;
  selectedGroupId: string | null;
  groups: GroupSelectorGroup[];
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchClear: () => void;
  onFilterChange: (period: FilterPeriod) => void;
  onGroupChange: (groupId: string | null) => void;
  /** Ação inline na altura do search (ex: botão Adicionar) */
  searchAction?: React.ReactNode;
}

export const FiltersSection = ({
  search,
  filterPeriod,
  selectedGroupId,
  groups,
  onSearchChange,
  onSearchClear,
  onFilterChange,
  onGroupChange,
  searchAction,
}: FiltersSectionProps) => {
  const { t } = useTranslation();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const hasActiveFilter = filterPeriod !== "all" || selectedGroupId !== null;

  return (
    <div className={styles["filters-section"]}>
      <div className={styles["filters-section__search-row"]}>
        <SearchBar
          value={search}
          onChange={onSearchChange}
          onClear={onSearchClear}
        />
        <button
          type="button"
          onClick={() => setIsFilterOpen(true)}
          className={`${styles.filterBtn} ${hasActiveFilter ? styles.filterBtnActive : ""}`}
          aria-label={t("filter.title", "Filter")}
          title={t("filter.title", "Filter")}
        >
          <SlidersHorizontal size={20} />
          {hasActiveFilter && <span className={styles.filterBadge} />}
        </button>
        {searchAction}
      </div>

      <FilterBottomSheet
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        filterPeriod={filterPeriod}
        selectedGroupId={selectedGroupId}
        groups={groups}
        onFilterChange={onFilterChange}
        onGroupChange={onGroupChange}
      />
    </div>
  );
};

